<template>
  <div id="app">
    <router-view></router-view>


  </div>
</template>

<script>


export default {

  name: 'app',
  data() {
    return {

    }
  }
}
</script>

<style lang="sass">
@import "./components/assets/sass/site.sass"
</style>



// WEBPACK FOOTER //
// App.vue?8105b972